"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoIconOverlay;

var _react = _interopRequireDefault(require("react"));

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _UIIconCircle = _interopRequireDefault(require("UIComponents/icon/UIIconCircle"));

function VideoIconOverlay() {
  return _react.default.createElement("div", {
    className: "video-icon-overlay align-center justify-center"
  }, _react.default.createElement(_UIIconCircle.default, {
    name: "playerPlay",
    color: colors.OLAF,
    backgroundColor: colors.OBSIDIAN,
    borderWidth: 0,
    size: 9,
    padding: 0.2,
    iconClassName: "m-right-0"
  }));
}

module.exports = exports.default;